import React from 'react'

const Button = () => {
  return (
    <div><button className='common_btn'>Hire me</button></div>
  )
}

export default Button